import type { Jet } from '~/jet';
import type { CommerceModalAction } from '~/actions/commerce-modal-action';
import type { LoggerFactory } from '@amp/web-apps-logger';
// Safe because this file is only imported from ./browser.ts
import type { Playback } from '~/utils/playback/browser-only';
import type { Commerce } from '~/utils/commerce/browser-only';
import { CommerceRoute } from '~/utils/commerce';
import { isCommerceModalOpen } from '@amp/web-app-components/src/stores/needs-gdpr';
import { get } from 'svelte/store';
import { getCookie } from '@amp/web-app-components/src/utils/cookie';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
    playback: Playback;
    commerce: Commerce;
};

export function registerHandler(dependencies: Dependencies) {
    const { jet, logger, commerce, playback } = dependencies; // TODO: musickit as a dependency, need router or current route here

    const log = logger.loggerFor('jet/action-handlers/commerce-modal-action');

    jet.onAction('commerceModalAction', async (action: CommerceModalAction) => {
        log.info('received CommerceModal:', action);
        const isModalAlreadyOpen = get(isCommerceModalOpen);
        switch (action.operation.activePath) {
            case CommerceRoute.logout:
                await commerce.logout();
                break;
            case CommerceRoute.authenticate:
                // If user does not seem like they are signed in, but the MUT
                // exists, it means they probably signed in via another tab,
                // just update the local auth state. The `isAuthorized()` usage
                // does not make network calls, the promise resolution will be
                // quick.
                if (
                    getCookie('media-user-token') &&
                    !(await playback.isAuthorized())
                ) {
                    playback.updateUserTokenFromStorage();
                    if (await playback.isAuthorized()) {
                        // Call me(), to check for GDPR. This call does not
                        // need the result, so do not await.
                        playback.me().catch((e) => {
                            /* ignore */
                        });
                        break;
                    }
                }
            // Otherwise fall through to the default case below
            default:
                if (!isModalAlreadyOpen) {
                    await commerce.open(
                        action.operation.activePath,
                        action.operation.modalParams,
                    );
                    break;
                }
        }
        return 'performed';
    });
}
